const getPicksByState = (state) => state.map(({endpointId, serviceId, quantity, untie}) => ({
    endpoint: endpointId,
    service: serviceId,
    quantity: quantity,
    ...(untie && {untie: {
        currency: untie.currency,
        price: untie.price
    }})
}));

export default getPicksByState;